import { render, staticRenderFns } from "./CallContentSettings.vue?vue&type=template&id=6c30b8b8&scoped=true&"
import script from "./CallContentSettings.vue?vue&type=script&lang=js&"
export * from "./CallContentSettings.vue?vue&type=script&lang=js&"
import style0 from "./CallContentSettings.vue?vue&type=style&index=0&id=6c30b8b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c30b8b8",
  null
  
)

export default component.exports